import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { config } from 'config';
import { Wrap, Trigger, Flag, Caret, Menu, Item } from './lang-selector.styled';

const LANGS = [
  { code: 'ru', label: 'RU', native: 'Русский' },
  { code: 'en', label: 'EN', native: 'English' },
];

const CaretIcon = () => (
  <Caret viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden>
    <path d="M6 9l6 6 6-6" />
  </Caret>
);

/**
 * Compact language dropdown (CleverParking style): a pill showing the current
 * flag + code that opens a dark menu of languages with their native names.
 */
export const LangSelector = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [open]);

  if (!config.use_lang) {
    return null;
  }

  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  const changeLang = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('lang', code);
    setOpen(false);
  };

  return (
    <Wrap ref={ref}>
      <Trigger type="button" aria-expanded={open} aria-label="Выбор языка" onClick={() => setOpen((v) => !v)}>
        <Flag src={'/images/flags/' + current.code + '.svg'} alt={current.code} />
        {current.label}
        <CaretIcon />
      </Trigger>
      {open && (
        <Menu role="listbox">
          {LANGS.map((l) => (
            <Item key={l.code} type="button" role="option" aria-selected={l.code === current.code} $active={l.code === current.code} onClick={() => changeLang(l.code)}>
              <Flag src={'/images/flags/' + l.code + '.svg'} alt={l.code} />
              <span className="native">{l.native}</span>
              <span className="code">{l.label}</span>
            </Item>
          ))}
        </Menu>
      )}
    </Wrap>
  );
};
